
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"#222"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Grupo 5790"}},[_c('path',{attrs:{"data-name":"Unión 292","d":"M.289 11.905a.651.651 0 010-.92l4.888-4.888L.19 1.111a.651.651 0 010-.92.651.651 0 01.92 0l4.986 4.987L11.082.192a.651.651 0 01.92 0 .651.651 0 010 .92L7.016 6.098l4.887 4.887a.65.65 0 010 .919.65.65 0 01-.919 0L6.097 7.017l-4.888 4.888a.65.65 0 01-.46.19.648.648 0 01-.46-.19z"}})])])
          )
        }
      }
    